
import { Trail } from "atlasguides-web-common/src/functions/guides/dto/guide-geo.dto";
import { GuideGeoExt } from "commonTypes/GuideUse/guideGeo";

import RBush from 'rbush';
import knn from 'rbush-knn';

export type TrailPoint = { latitude: number; longitude: number; elevation: number; distance: number; trail: Trail};

type TreeNode = { 
    minX: number; // Longitude
    minY: number; // Latitude
    maxX: number; // Longitude
    maxY: number; // Latitude
    id?: number;
    point: TrailPoint;
};

export class RouteTree {

    private tree = new RBush<TreeNode>();
    private guideData: GuideGeoExt;

    // Public static initializer
    public static initFromGuideData(guideData: GuideGeoExt): RouteTree {
        const instance = new RouteTree(guideData);
        guideData.routeTree = instance; // Assign the instance to the guide data
        return instance;
    }

    // Private constructor to prevent direct instantiation
    private constructor(guide: GuideGeoExt) {
        this.guideData = guide;
        this.initializeTree();
    }

    public getNearestPoint(lat: number, lon: number): TrailPoint | null {
        const neighbors = knn(this.tree, lon, lat, 1);
        if (neighbors.length === 0) {
            return null; // No points found within the threshold
        }
        return neighbors[0].point;
    }

    public getNearestPointThreshold(lat: number, lon: number, maxMeters: number): TrailPoint | null {
        const degDistance = this.metersToDegreesLat(maxMeters);
        const neighbors = knn(this.tree, lon, lat, 1, undefined, degDistance);
        if (neighbors.length === 0) {
            return null; // No points found within the threshold
        }
        return neighbors[0].point;
    }

    private initializeTree() {
        this.guideData.trails.forEach(trail => {
            trail.geometry.coordinates[0].forEach(([lon, lat, elevation, distance]) => {
                this.tree.insert({ 
                    minX: lon, minY: lat, maxX: lon, maxY: lat, id: trail.id,
                    point: {
                        latitude: lat,
                        longitude: lon,
                        elevation,
                        distance,
                        trail: trail
                    }
                });
            });
        });
    }    

    private metersToDegreesLat = (meters: number) => meters / 111_000;
    private metersToDegreesLon = (meters: number, lat: number) =>
        meters / (111_320 * Math.cos(lat * Math.PI / 180));
    
}
